import client from "./client";

const save = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
  URL.revokeObjectURL(url);
};

const stamp = () => new Date().toISOString().slice(0, 10);

export const downloadMyData = async (lang = "ar") => {
  const res = await client.get("/profile/me/export", { params: { lang }, responseType: "blob" });
  save(res.data, `helcoo-my-data-${stamp()}.zip`);
};

export const downloadEmployeeData = async (userId, lang = "ar") => {
  const res = await client.get(`/profile/${userId}/export`, { params: { lang }, responseType: "blob" });
  save(res.data, `helcoo-employee-${userId}-${stamp()}.zip`);
};
